import { Component } from '@angular/core';
import { CommonService, DocumentsService, UserService } from '../../../services/common';
import { SalesService } from '../sales.service';
import { DocumentSubType, UserSubType } from '../../../../appconfig';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrl: './client.component.scss'
})
export class ClientComponent {
  formcofigData: any;

  namecont = true;
  identifi = false;
  bankaccount = false;
  clientData: any;
  showaddUpdateModal: boolean = false;
  currentSelectedRecourd: any;
  customerSupportData: any;
  customerId: any = 0;
  context: string = '';

  private destroy$ = new Subject<void>();

  constructor(public userService: UserService, private saleservice: SalesService, public commonService: CommonService,
    public route: ActivatedRoute, public router: Router, private documentService: DocumentsService) {
  }

  ngOnInit() {
    this.formcofigData = {
      "showexportButton": true,
      "showAddButton": true
    }
    this.customerId = this.route.snapshot.paramMap.get("id")!;
    this.getClientData()
  }


  /**
   * Client Get API
   */
  getClientData() {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {
        this.clientData = [];
        if (selectedProject != null) {
          this.saleservice.getFilterUser(null, selectedProject.id, UserSubType.Client).subscribe((res: any) => {
            if (res != null) {
              this.clientData = res?.result?.map((data: any) => {
                data.clientName = data?.nameInitial?.name + '.' + ' ' + data?.firstName + ' ' + data?.lastName;
                return data;
              })
            }

            if (this.customerId != null && this.customerId != "undefined") {

              let filterPlanObject = {
                showaddUpdateModal: true,
                currentRecord: this.clientData?.find((filter: any) => filter.id == parseInt(this.customerId)),
                isSubmitted: false
              }
              this.changeAddUpdateModelState(filterPlanObject);
            }
          });
        }
      });
  }

  changeAddUpdateModelState(modalStatus: any) {
    if (modalStatus?.showaddUpdateModal) {
      this.customerSupportData = modalStatus?.currentRecord;
    }
    this.showaddUpdateModal = modalStatus?.showaddUpdateModal as boolean;

    // Handle customer data updated from bank account component
    if (modalStatus?.customerDataUpdated) {
      // Update the customer in the clientData array so changes persist
      const customerIndex = this.clientData?.findIndex((customer: any) =>
        customer.id === modalStatus.customerDataUpdated.id
      );
      if (customerIndex > -1) {
        this.clientData[customerIndex] = modalStatus.customerDataUpdated;
        this.customerSupportData = modalStatus.customerDataUpdated;
      }
    }

    if (modalStatus?.isSubmitted)
      this.getClientData();
  }

  /**
  * Click Close Model Form
  */
  closeCustomerDialogue() {
    this.userService.isCustomerData = false;
  }

  userProfileData: any;
  usereditData: any;
  userDocumentsData: any;
  userDataFromuserList: any;
  /**
 * This method will subscribed to currently selected booking, by user on booking list
 * whose documents he wants to see
 */
  getCurrentSelectedBookingCustomer() {
    if (this.customerSupportData) {
      //Get customer details of current booking
      this.userService.getFilterUser(null, null, null, this.customerSupportData?.customerDetail?.id).subscribe((res: any) => {
        if (res) {
          this.userProfileData = res?.result[0];
          this.usereditData = res?.result[0];
          //if User profile data is available then we can find the list of total documents available of this user
          this.documentService.getFilterDocument(this.userProfileData?.id).subscribe(userDocs => {
            var profilePicData: any = null;
            if (userDocs?.result?.length > 0) {
              //set list of all documents of users so that it can be used on KYC Panel too
              this.userDocumentsData = userDocs?.result
              //Check if user has pic data already uploaded or not.
              profilePicData = userDocs?.result?.find((x: any) => x.documentSubTypeId == DocumentSubType.Photo)
              //Sets the user data object
              this.userDataFromuserList = {
                "userProfileData": this.userProfileData,
                "profilePicfile": profilePicData
              }
            }
          });
        }
      });
    }
  }
}


